import * as React from 'react';
import { ChatActions, ChatState } from './Store';
import { sendMessage, sendFiles } from './Chat';
import { connect } from 'react-redux';
import { Strings } from './Strings';
import { polyfill } from 'smoothscroll-polyfill';
import { AutoSuggest } from './auto-suggest';
import { adjustArea, getDevice } from './utilites';

interface Props {
    inputText: string,
    strings: Strings,
    candidates: string[],

    onChangeText: (inputText: string) => void

    sendMessage: (inputText: string, channelData:any) => void,
    sendFiles: (files: FileList) => void,
    options: any
    isHelpPopupHide?: boolean
}

interface StateProps {
    isHelpPopupHide : boolean
}

class ShellContainer extends React.Component<Props, StateProps> {
    private textInput: HTMLInputElement;
    private fileInput: HTMLInputElement;
    private helpPopup: HTMLParagraphElement;
    private inputCount: number = 0;
    private element: any;
    private dataProps: Props;
    private firstAsked: boolean = false;
    private isHelpPopupHide : boolean = false;

    constructor(props: Props) {
        super(props);
        this.dataProps = this.props;

        this.state = {
            isHelpPopupHide : typeof props.isHelpPopupHide !== "undefined" ? props.isHelpPopupHide : false
        };
        this.isHelpPopupHide = this.state.isHelpPopupHide;

        // 有人チャット遷移用cookie削除（初回アクセス時）
        document.cookie = "escalationInfoEntitiy=; max-age=0";
        document.cookie = "same_answer_count=; max-age=0";
        document.cookie = "escalation_flg=; max-age=0";
        document.cookie = "interPersonalChatStatus=; max-age=0";
        document.cookie = "otsuuLoginState=; max-age=0";
        document.cookie = "conversationID=; path=/; max-age=0";
        document.cookie = "chat_ask_type=; path=/; max-age=0";
        document.cookie = "bearerToken=; path=/; max-age=0";

        // IE対応
        var dt = new Date('1999-12-31T23:59:59Z'); // 過去の日付をGMT形式に変換
        document.cookie = "escalationInfoEntitiy=; expires=" + dt.toUTCString();
        document.cookie = "same_answer_count=; expires=" + dt.toUTCString();
        document.cookie = "escalation_flg=; expires=" + dt.toUTCString();
        document.cookie = "interPersonalChatStatus=; expires=" + dt.toUTCString();
        document.cookie = "otsuuLoginState=; expires=" + dt.toUTCString();
        document.cookie = "conversationID=; path=/; expires=" + dt.toUTCString();
        document.cookie = "chat_ask_type=; path=/; expires=" + dt.toUTCString();
        document.cookie = "bearerToken=; path=/; expires=" + dt.toUTCString();

        polyfill();
    }

    shouldComponentUpdate(nextProps: Props) {
        if (this.dataProps !== nextProps) {
            this.dataProps = nextProps;
        }
        return true;
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.dataProps !== nextProps) {
            if (typeof nextProps.isHelpPopupHide !== "undefined" && this.inputCount === 0) {
                this.setState({ isHelpPopupHide : nextProps.isHelpPopupHide });
                this.isHelpPopupHide = nextProps.isHelpPopupHide;
            }
        }
    }

    private sendMessage() {
        if (this.props.inputText.trim().length > 0) {
            let data = {
                inputText : this.props.inputText,
                clientData: null as any
            };
            if (this.props.options.beforeAsking &&
                typeof this.props.options.beforeAsking === "function") {
                const returnData = this.props.options.beforeAsking(this.dataProps, data);
                this.dataProps = returnData.props;
                data = returnData.data;
            }

            this.adjustArea();
            this.element.clearValue();

            this.props.sendMessage(data.inputText, {clientData: data.clientData});
        }
    }

    // 高さ揃えとスムーススクロール
    private adjustArea() {
        if (!this.firstAsked) {
            let adjustAreaFlag = false;
            if (typeof this.props.options.adjustArea === "function") {
                adjustAreaFlag = this.props.options.adjustArea();
            } else {
                adjustAreaFlag = this.props.options.adjustArea;
            }

            if (adjustAreaFlag) {
                // 高さ揃え
                adjustArea();

                setTimeout ( () => document.querySelector(".chatbot-area").scrollIntoView({ block:"start", behavior: "smooth" }), 100);

                // スクロール
                /*scrollToElement(document.querySelector(".chatbot-area"), {
                    offset : -20,
                    ease : "outQuad",
                    duration : 300
                });*/
            }

            this.firstAsked = true;
        }
    }

    // 入力欄でEnterキーによる送信
    private _onKeyPress(key:any) {
        if (key === "Enter") {
            this.sendMessage();
            if (getDevice !== "other") this.textInput.blur();
        }
    }

    // ボタンによる送信
    private onClickSend(e:any) {
        e.preventDefault();
        this.sendMessage();
    }

    private onChangeFile() {
        this.textInput.focus();
        this.props.sendFiles(this.fileInput.files);
        this.fileInput.value = null;
    }

    /**
     * 有人チャットの開始画面へ遷移
     */
    linkEscalationStart = () => {
        if (this.props.options.mannedLink) {
            window.open(this.props.options.mannedLink);
        }
    };

    render() {
        let className = "wc-console";
        if (this.props.inputText.length > 0) className += " has-text";

        const candidateLists = this.props.candidates ? this.props.candidates.map(candidate => {
            return { key : "candidate-" + candidate, text : candidate };
        }) : [];

        let suggestLimit = 0;
        if (typeof this.props.options.suggestLimit === "function") {
            suggestLimit = (this.props.options.suggestLimit()) ? this.props.options.suggestLimit() : 0;
        } else {
            suggestLimit = (this.props.options.suggestLimit) ? this.props.options.suggestLimit : 0;
        }

        //cookie情報取得
        let visibleEscalationButton = false;
        let contactID;
        let interPersonalChatStatus = false;
        let always_display = false
        var r = document.cookie.split(";");
        r.forEach(function(value:any){
            //cookie名と値に分ける
            const content = value.split("=");
            const contentData = decodeURIComponent(content[1]) || "{}";
            if(content[0].trim() == "escalationInfoEntitiy"){
                contactID = JSON.parse(contentData).contactID;
                always_display = JSON.parse(contentData).always_display;
            }else if(content[0].trim() == "interPersonalChatStatus"){
                interPersonalChatStatus = (contentData.toLowerCase() == "true") ? true : false;
            }
        });
        //オペレータにつなぐボタン表示判定
        visibleEscalationButton = (contactID && interPersonalChatStatus && always_display);

        return (
            <div className={className}>
                <p className={`help-popup ${this.isHelpPopupHide ? "hide" : "show"}`} ref={ (elem:any) => this.helpPopup = elem }>こちらにどうぞ<span className="note">（個人が特定できる情報の入力はご遠慮ください）</span></p>
                <AutoSuggest
                    ref={ (el:any) => this.element = el }
                    items={ candidateLists || [] }
                    max={ suggestLimit }
                    autoFocus={ true }
                    placeholder={ this.props.strings.consolePlaceholder }
                    onChange={ (text:string) => {
                        // ヘルプを非表示にするフラグ
                        if (this.inputCount === 0) {
                            this.isHelpPopupHide = true;
                        }
                        this.inputCount += 1;

                        this.props.onChangeText(text);
                    } }
                    onKeyPress={ (e:any, text:string) => {
                        this.textInput = e.currentTarget;
                        this.props.onChangeText(text);

                        const key = e.key;
                        const self = this;

                        setTimeout(() => self._onKeyPress(key), 0);
                    } }
                 />
                 <p className="btn-question"><a role="button" onClick={ (event:any) => { this.onClickSend(event); } }>{ this.props.strings.send }</a></p>
                 { visibleEscalationButton ?
                 <button type="button" className="btn-connect-operator" onClick={ this.linkEscalationStart }>オペレーター<br/>につなぐ</button>
                 : null }
            </div>
        );
    }
}

export const Shell = connect(
    (state: ChatState) => ({
        // passed down to ShellContainer
        inputText: state.shell.input,
        strings: state.format.strings,
        candidates: state.shell.candidates,
        // only used to create helper functions below
        locale: state.format.locale,
        user: state.connection.user,
    }), {
        // passed down to ShellContainer
        onChangeText: (input: string) => {

            return { type: 'Update_Input', input } as ChatActions
        },
        // only used to create helper functions below
        sendMessage,
        sendFiles
    }, (stateProps: any, dispatchProps: any, ownProps: any): Props => ({
        // from stateProps
        inputText: stateProps.inputText,
        strings: stateProps.strings,
        candidates: stateProps.candidates,
        // from dispatchProps
        onChangeText: dispatchProps.onChangeText,
        // helper functions
        sendMessage: (text: string, channelData:any) => {
            dispatchProps.sendMessage(text, stateProps.user, stateProps.locale, channelData);
        },
        sendFiles: (files: FileList) => dispatchProps.sendFiles(files, stateProps.user, stateProps.locale),
        options: ownProps.options,
        isHelpPopupHide: ownProps.isHelpPopupHide
    })
)(ShellContainer);



// WEBPACK FOOTER //
// ./src/Shell.tsx